import {URL_BASE_API } from '../../../configs/urlConfigs'; 

import service from '../../api';

export const aflt_stcbonusList = (request) => {
    let ENDPOINT = '';
    ENDPOINT = URL_BASE_API+'affiliate/callbonus/?skill='+request.data;
    return service.get(ENDPOINT);    
}; 

export const aflt_stcbonusAdd = (request) => {
  const ENDPOINT = URL_BASE_API+'affiliate/callbonus/';
  return service.post(ENDPOINT,request.data);  
};  

export const aflt_stcbonusUpdate = (request) => {
  let stcbonusId = request.data.id;
  const ENDPOINT = URL_BASE_API+'affiliate/callbonus/'+stcbonusId;
  return service.put(ENDPOINT,request.data);
};

export const aflt_stcbonusDelete = (request) => {
  const ENDPOINT = URL_BASE_API+'affiliate/callbonus/'+request.data;
  return service.delete(ENDPOINT);  
};  
